/* eslint-disable max-len */
import HF1 from '../static/images/detail-service-product/hf/1.webp'
import HF2 from '../static/images/detail-service-product/hf/2.webp'
import HF3 from '../static/images/detail-service-product/hf/3.webp'
import HF4 from '../static/images/detail-service-product/hf/4.webp'

import HC1 from '../static/images/detail-service-product/hc/1.webp'
import HC2 from '../static/images/detail-service-product/hc/2.webp'
import HC3 from '../static/images/detail-service-product/hc/3.webp'
import HC4 from '../static/images/detail-service-product/hc/4.webp'

import HM1 from '../static/images/detail-service-product/hm/1.webp'
import HM2 from '../static/images/detail-service-product/hm/2.webp'
import HM3 from '../static/images/detail-service-product/hm/3.webp'
import HM4 from '../static/images/detail-service-product/hm/4.webp'
import HM5 from '../static/images/detail-service-product/hm/5.webp'
import HM6 from '../static/images/detail-service-product/hm/6.webp'
import HM7 from '../static/images/detail-service-product/hm/7.webp'
import HM8 from '../static/images/detail-service-product/hm/8.webp'
import HM9 from '../static/images/detail-service-product/hm/9.webp'
import HM10 from '../static/images/detail-service-product/hm/10.webp'
import HM11 from '../static/images/detail-service-product/hm/11.webp'
import HM12 from '../static/images/detail-service-product/hm/12.webp'
import HM13 from '../static/images/detail-service-product/hm/13.webp'
import HM14 from '../static/images/detail-service-product/hm/14.webp'

const content_type = {
  DURATION: 'DURATION',
  CHECKLIST: 'CHECKLIST',
  CROSS: 'CROSS',
  BULLET: 'BULLET',
  TOTAL_DURATION: 'TOTAL_DURATION',
  DURATION_CHOICE: 'DURATION_CHOICE',
  DURATION_WITH_SIZE: 'DURATION_WITH_SIZE',
  VENDOR_EQUIPMENT: 'VENDOR_EQUIPMENT'
}

const detail_service_product = {
  HF: [
    {
      id: 1,
      image: HF1,
      title: 'Panduan layanan Cuci Ac',
      subtitle: [
        'Berikut informasi standar operasional untuk pengerjaan teknis cuci AC yang dapat disampaikan kepada pelanggan kami.'
      ],
      alert_card:
        'Kami tidak bertangung jawab atas transaksi yang terjadi diluar aplikasi Halo Jasa, mohon melakukan konfirmasi kepada teknisi apabila tidak tersedia tangga ditempat anda.',
      content: [
        {
          id: 1,
          type: 'DURATION',
          detail_content: [
            {
              id: 1,
              title: 'Pengechekan Unit & Bongkar Filter',
              subtitle: '+/- 15 menit'
            },
            {
              id: 2,
              title: 'Pembersihan Mesin Indoor',
              subtitle: '+/- 15 menit'
            },
            {
              id: 3,
              title: 'Pembersihan Mesin Outdoor',
              subtitle: ' +/- 10 menit'
            },
            {
              id: 4,
              title: 'Pembersihan Area Pengerjaan',
              subtitle: '+/- 10 menit'
            }
          ]
        },
        {
          id: 2,
          type: 'CHECKLIST',
          title: 'Pengerjaan Teknisi ac mencangkup :',
          detail_content: [
            {
              id: 1,
              title:
                'Pemeriksaan Awal AC: Evaluasi kondisi unit AC untuk menentukan tingkat kotoran dan masalah yang mungkin ada.'
            },
            {
              id: 2,
              title:
                'Pembersihan Komponen AC: Membersihkan filter udara, evaporator, kondensor, dan bagian-bagian lain dari kotoran, debu.'
            },
            {
              id: 3,
              title:
                'Pemeriksaan Kembali dan Pengujian: Memeriksa kembali AC setelah pembersihan untuk memastikan kinerja optimal.'
            },
            {
              id: 4,
              title: 'Penyelesaian : Pembersihan Area Pengerjaan.'
            }
          ]
        },
        {
          id: 3,
          type: 'CROSS',
          title: 'Pengerjaan Layanan tidak termasuk :',
          detail_content: [
            {
              id: 1,
              title: 'Penggunaan Bahan Chemical Pembersih Khusus'
            },
            {
              id: 2,
              title: 'Pembersihan Unit Ac central'
            },
            {
              id: 3,
              title: 'Pembersihan Unit indor & Outdoor Langit-Langit (casset)'
            }
          ]
        },
        {
          id: 4,
          type: 'VENDOR_EQUIPMENT',
          title: 'Peralatan & Perlengkapan :',
          detail_content: [
            {
              id: 1,
              title: 'Tools set'
            },
            {
              id: 2,
              title: 'Mesin Steamer'
            },
            {
              id: 3,
              title: 'Tang Ampere'
            },
            {
              id: 4,
              title: 'Pressure Gauge Ac'
            },
            {
              id: 5,
              title: 'Cleaning Cover Waterproof'
            }
          ]
        },
        {
          id: 5,
          type: 'BULLET',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Teknisi Melakukan Pemeriksaan Kembali dan Pengujian kembali AC setelah pembersihan untuk memastikan kinerja optimal.'
            },
            {
              id: 2,
              title:
                'Pengchekan kondisi Awal internal AC sebelum dan sesudah pembersihan dapat berbeda, tergantung pada tingkat kotoran dan kondisi internal unit.'
            },
            {
              id: 3,
              title:
                'Hasil Pembersihan pada kinerja AC tidak selalu dijamin setelah pembersihan terutama jika ada masalah mekanis lain yang tidak terkait dengan kotoran atau terkait teknis kerusakan komponen.'
            },
            {
              id: 4,
              title:
                'Rekomendasi Perawatan Lanjutan dan pencatatan volume tekanan freon'
            },
            {
              id: 5,
              title:
                'Harga sudah termasuk Asuransi, mohon dapat membaca ketentuan asuransi kliem kami.'
            },
            {
              id: 6,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 2,
      image: HF2,
      title: 'Panduan layanan Bongkar Ac',
      subtitle: [
        'Berikut informasi standar operasional untuk pengerjaan teknis Bongkar mesin AC yang dapat disampaikan kepada pelanggan kami.'
      ],
      alert_card:
        'Kami tidak bertangung jawab atas transaksi yang terjadi diluar aplikasi Halo Jasa, mohon melakukan konfirmasi kepada teknisi apabila tidak tersedia tangga ditempat anda.',
      content: [
        {
          id: 1,
          type: 'DURATION',
          detail_content: [
            {
              id: 1,
              title: 'Pengechekan Unit',
              subtitle: '+/- 10 meni'
            },
            {
              id: 2,
              title: 'Bongkar / Copot Mesin Indoor',
              subtitle: '+/- 40 menit'
            },
            {
              id: 3,
              title: 'Bongkar / Copot Mesin Outdoor',
              subtitle: '+/- 10 menit'
            },
            {
              id: 4,
              title: 'Pembersihan Area Pengerjaan',
              subtitle: '+/- 10 menit'
            }
          ]
        },
        {
          id: 2,
          type: 'CHECKLIST',
          title: 'Pengerjaan Teknisi ac mencangkup :',
          detail_content: [
            {
              id: 1,
              title:
                'Pemeriksaan Awal AC: Evaluasi kondisi unit AC untuk menentukan apakah akan ada terjadi resiko apabila kerusakan apabila dicopot.'
            },
            {
              id: 2,
              title:
                'Pemutusan Listrik dan Pengosongan Refrigeran: Langkah awal untuk mematikan dan mengosongkan refrigeran yang terdapat dalam unit indoor.'
            },
            {
              id: 3,
              title:
                'Pemeriksaan & Penyelesaian : Memeriksa kembali  unit AC yang telah dicopot dan penyerahkan kepada pelangan serta membersihkan area pengerjaan.'
            }
          ]
        },
        {
          id: 3,
          type: 'CROSS',
          title: 'Pengerjaan Layanan tidak termasuk :',
          detail_content: [
            {
              id: 1,
              title: 'Pemasangan  Unit Ac '
            },
            {
              id: 2,
              title: 'Pembersihan Cuci Unit indor & Outdoor'
            }
          ]
        },
        {
          id: 4,
          type: 'VENDOR_EQUIPMENT',
          title: 'Peralatan & Perlengkapan :',
          detail_content: [
            {
              id: 1,
              title: 'Tools set'
            },
            {
              id: 2,
              title: 'Tang Ampere'
            },
            {
              id: 3,
              title: 'Pressure Gauge Ac'
            }
          ]
        },
        {
          id: 5,
          type: 'BULLET',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Teknisi Melakukan Pemeriksaan Kembali atas kelengkapan komponen perangkat.'
            },
            {
              id: 2,
              title:
                'Kondisi akhir pemasangan kembali AC bisa dipengaruhi oleh struktur rumah atau sistem listrik yang ada, dan bisa memerlukan penyesuaian tambahan.'
            },
            {
              id: 3,
              title:
                'Hasil dan Kinerja Setelah Bongkar AC Perbaikan kinerja AC tidak selalu dijamin setelah bongkar AC terutama jika ada masalah mekanis lain yang ditemukan selama proses bongkar baik itu faktor perangkat komponen yang telah rusak atau berkinerja rendah'
            },
            {
              id: 4,
              title:
                'Harga sudah termasuk Asuransi, mohon dapat membaca ketentuan asuransi kliem kami.'
            },
            {
              id: 5,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 3,
      image: HF3,
      title: 'Panduan layanan Pasang Ac',
      subtitle: [
        'Berikut informasi standar operasional untuk pengerjaan teknis pasang mesin AC yang dapat disampaikan kepada pelanggan kami.'
      ],
      alert_card:
        'Kami tidak bertangung jawab atas transaksi yang terjadi diluar aplikasi Halo Jasa, mohon melakukan konfirmasi kepada teknisi apabila tidak tersedia tangga ditempat anda.',
      content: [
        {
          id: 1,
          type: 'DURATION',
          detail_content: [
            {
              id: 1,
              title: 'Pengechekan Unit',
              subtitle: '+/- 10 menit'
            },
            {
              id: 2,
              title: 'Pasang instalasi ',
              subtitle: '+/- 20 menit'
            },
            {
              id: 3,
              title: 'Pasang  Mesin Indoor & Outdoor',
              subtitle: '+/- 60 menit'
            },
            {
              id: 4,
              title: 'Pembersihan Area Pengerjaan',
              subtitle: '+/- 10 menit'
            }
          ]
        },
        {
          id: 2,
          type: 'CHECKLIST',
          title: 'Pengerjaan Teknisi ac mencangkup :',
          detail_content: [
            {
              id: 1,
              title:
                'Pemilihan Lokasi yang Tepat: Evaluasi dan pemilihan lokasi yang optimal untuk pemasangan unit AC indoor dan outdoor.'
            },
            {
              id: 2,
              title:
                'Pemasangan Unit Indoor: Instalasi unit indoor di dalam ruangan yang melibatkan penempatan dudukan, pemasangan pipa, dan kabel listrik.'
            },
            {
              id: 3,
              title:
                'Pemasangan Unit Outdoor: Pemasangan unit outdoor yang melibatkan dudukan, penghubungan pipa refrigeran, dan kabel listrik.'
            },
            {
              id: 4,
              title:
                'Pengujian dan Penyesuaian: Pengujian ulang untuk memastikan semua komponen berfungsi dengan baik.'
            },
            {
              id: 5,
              title: 'Penyelesaian : Pembersihan Area Pengerjaan'
            }
          ]
        },
        {
          id: 3,
          type: 'CROSS',
          title: 'Pengerjaan Layanan tidak termasuk :',
          detail_content: [
            {
              id: 1,
              title: 'Pembongkaran unit ac lama'
            },
            {
              id: 2,
              title: 'Pembersihan Cuci Unit Ac indoor & Outdoor'
            },
            {
              id: 3,
              title: 'Isi ataupun  penambahan freon'
            },
            {
              id: 4,
              title: 'Penyelesaian : Pembersihan Area Pengerjaan'
            }
          ]
        },
        {
          id: 4,
          type: 'VENDOR_EQUIPMENT',
          title: 'Peralatan & Perlengkapan :',
          detail_content: [
            {
              id: 1,
              title: 'Tools set'
            },
            {
              id: 2,
              title: 'Mesin Steamer'
            },
            {
              id: 3,
              title: 'Tang Ampere'
            },
            {
              id: 4,
              title: 'Pressure Gauge Ac'
            }
          ]
        },
        {
          id: 5,
          type: 'BULLET',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Teknisi Melakukan Pemeriksaan Kembali kelengkapan komponen ac dan Pengujian setelah pemasangan untuk memastikan kinerja optimal.'
            },
            {
              id: 2,
              title:
                'Kondisi internal rumah atau lingkungan dapat memengaruhi proses pemasangan dan memerlukan penyesuaian tambahan.'
            },
            {
              id: 3,
              title:
                'Hasil kinerja AC tidak selalu dijamin setelah pemasangan terutama jika ada masalah mekanis lain yang tidak terkait dengan kondisi kerusakan komponen pada ac lama.'
            },
            {
              id: 4,
              title:
                'Rekomendasi Perawatan Lanjutan akan disaran untuk pemeliharaan rutin oleh pemilik AC agar kinerja AC tetap optimal setelah pembersihan.'
            },
            {
              id: 5,
              title:
                'Harga sudah termasuk Asuransi, mohon dapat membaca ketentuan asuransi kliem kami.'
            },
            {
              id: 6,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 4,
      image: HF4,
      title: 'Panduan layanan Bongkar Pasang Ac',
      subtitle: [
        'Berikut informasi standar operasional untuk pengerjaan teknis bongkar dan pasang AC yang dapat disampaikan kepada pelanggan kami.'
      ],
      alert_card:
        'Kami tidak bertangung jawab atas transaksi yang terjadi diluar aplikasi Halo Jasa, mohon melakukan konfirmasi kepada teknisi apabila tidak tersedia tangga ditempat anda.',
      content: [
        {
          id: 1,
          type: 'DURATION',
          detail_content: [
            {
              id: 1,
              title: 'Pengechekan Unit ',
              subtitle: '+/- 10 menit'
            },
            {
              id: 2,
              title: 'Bongkar Mesin Indoor & Outdoor',
              subtitle: '+/- 40 menit'
            },
            {
              id: 3,
              title: 'Pasang / instalasi Mesin indoor & Outdoor',
              subtitle: ' +/- 80 menit'
            },
            {
              id: 4,
              title: 'Pembersihan Area Pengerjaan',
              subtitle: '+/- 10 menit'
            }
          ]
        },
        {
          id: 2,
          type: 'CHECKLIST',
          title: 'Pengerjaan Teknisi ac mencangkup :',
          detail_content: [
            {
              id: 1,
              title:
                'Pemeriksaan Awal AC: Evaluasi kondisi unit AC untuk menentukan apakah akan ada terjadi resiko apabila kerusakan apabila dicopot.'
            },
            {
              id: 2,
              title:
                'Pemilihan Lokasi yang Tepat: Evaluasi dan pemilihan lokasi yang optimal untuk pemasangan unit AC indoor dan outdoor.'
            },
            {
              id: 3,
              title:
                'Pembongkaran & Pemasangan Unit Outdoor: Pemasangan unit outdoor yang melibatkan dudukan, penghubungan pipa refrigeran, dan kabel listrik.'
            },
            {
              id: 4,
              title:
                'Pengujian dan Penyesuaian: Pengujian ulang untuk memastikan semua komponen berfungsi dengan baik.'
            },
            {
              id: 5,
              title: 'Penyelesaian : Pembersihan Area Pengerjaan.'
            }
          ]
        },
        {
          id: 3,
          type: 'CROSS',
          title: 'Pengerjaan Layanan tidak termasuk :',
          detail_content: [
            {
              id: 1,
              title: 'Penggunaan Bahan Chemical Pembersih Khusus'
            },
            {
              id: 2,
              title: 'Pembersihan Unit secara detail (Cuci ac)'
            },
            {
              id: 3,
              title: 'Isi ataupun  penambahan freon'
            }
          ]
        },
        {
          id: 4,
          type: 'VENDOR_EQUIPMENT',
          title: 'Peralatan & Perlengkapan :',
          detail_content: [
            {
              id: 1,
              title: 'Tools set'
            },
            {
              id: 2,
              title: 'Mesin Steamer'
            },
            {
              id: 3,
              title: 'Tang Ampere'
            },
            {
              id: 4,
              title: 'Pressure Gauge Ac'
            }
          ]
        },
        {
          id: 5,
          type: 'BULLET',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Teknisi Melakukan Pemeriksaan Kembali akan kelengkapan komponen ac unit baru / ac  unit lama.'
            },
            {
              id: 2,
              title:
                'Kondisi internal rumah atau lingkungan dapat memengaruhi proses pemasangan dan memerlukan penyesuaian tambahan.'
            },
            {
              id: 3,
              title:
                'Hasil kinerja AC tidak selalu dijamin setelah pemasangan terutama jika ada masalah mekanis lain yang tidak terkait dengan kondisi kerusakan atau pun kotoran pada komponen ac lama, yang tdk dicuci.'
            },
            {
              id: 4,
              title:
                'Rekomendasi Perawatan Lanjutan akan disaran untuk pemeliharaan rutin oleh pemilik AC agar kinerja AC tetap optimal setelah pembersihan.'
            },
            {
              id: 5,
              title:
                'Harga sudah termasuk Asuransi, mohon dapat membaca ketentuan asuransi kliem kami.'
            },
            {
              id: 6,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    }
  ],
  HC: [
    {
      id: 1,
      image: HC1,
      title: 'Panduan Paket Appartement / Kost',
      subtitle: [
        'Berikut ruangan yang termasuk dalam layanan paket cleaning apartement / kost beserta contoh luas dan estimasi waktu pengerjaannya, estimasi waktu dapat bervariasi tergantung pada paket layanan yang dipilih beserta ukuran unit dan kondisi kebersihan ruangan.'
      ],
      alert_card:
        ' Kami tidak bertangung jawab atas transaksi yang terjadi diluar aplikasi, Mohon memberi informasi kepada vendor kami apabila ingin mengunakan peralatan cleaning pribadi, termasuk menggunakan pengharum ruangan pribadi, sebelum pekerjaan dimulai.',
      content: [
        {
          id: 1,
          type: 'DURATION_CHOICE',
          title: 'Durasi pilihan pengerjaan :',
          content: [
            {
              id: 1,
              title: '45  menit  ( 1 Bedroom)'
            },
            {
              id: 2,
              title: '130 menit  ( 2 bed room)'
            },
            {
              id: 3,
              title: '180 menit  (3 bed room )'
            }
          ]
        },
        {
          id: 2,
          type: 'DURATION',
          detail_content: [
            {
              id: 1,
              title: 'Kamar Tidur',
              subtitle: '+/- 10-30  menit'
            },
            {
              id: 2,
              title: 'Kamar Mandi',
              subtitle: '+/- 20-30  menit'
            },
            {
              id: 3,
              title: 'Ruang Makan',
              subtitle: '+/- 10-30  menit'
            },
            {
              id: 4,
              title: 'Ruang keluarga',
              subtitle: '+/- 10-30  menit'
            },
            {
              id: 5,
              title: 'Ruang Tamu',
              subtitle: '+/-  10-30  menit'
            },
            {
              id: 6,
              title: 'Ruang Dapur',
              subtitle: '+/- 10--30  menit '
            }
          ]
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Pengerjaan Layanan ini meliputi :',
          detail_content: [
            {
              id: 1,
              title:
                'Standar dusting : mengelap & memberikan  debu dan kotoran di area,'
            },
            {
              id: 2,
              title: 'Standar Sweeping : menyapu dan mengepel lantai area'
            },
            {
              id: 3,
              title: 'Clean Area : Pembersihan dan pembuangan sampah'
            },
            {
              id: 4,
              title:
                'Layanan tambahan sesuai pesanan: pembersihan teras/ balkon setrika pakaian,cuci piring, pembersihan kitchenset dan pembersihan kulkas, pembersihan toran air.'
            }
          ]
        },
        {
          id: 4,
          type: 'CROSS',
          title: 'Layanan ini tidak termasuk, :',
          detail_content: [
            {
              id: 1,
              title:
                'Pembersihan area yang tidak bisa dijangkau dengan alat vendor kami.'
            },
            {
              id: 2,
              title:
                'Pembersihan jamur, kerak, cat, atau lumut, yang memerlukan cairan khusus.'
            },
            {
              id: 3,
              title: 'Pembersihan exhaust fan, atau kipas langit langit.'
            },
            {
              id: 4,
              title: 'Pembersihan lampu mewah langit langit.'
            },
            {
              id: 5,
              title:
                'Pembersihan saluran air yang mampet, serta pemasangan keran atau pipa.'
            },
            {
              id: 6,
              title: 'Pembersihan kotoran /kandang hewan dan/atau manusia.'
            },
            {
              id: 7,
              title: 'Pengangkutan dan pindahan barang.'
            },
            {
              id: 8,
              title: 'Pengurasan bak mandi, toren.'
            },
            {
              id: 9,
              title: 'Pembersihan barang mewah / koleksi pecah bela.'
            },
            {
              id: 10,
              title: 'Jemur dan angkat pakaian.'
            }
          ]
        },
        {
          id: 5,
          type: 'VENDOR_EQUIPMENT',
          title: 'Peralatan dan Perlengkapan vendor :',
          detail_content: [
            {
              id: 1,
              title: 'Lap microfiber'
            },
            {
              id: 2,
              title: 'Spons'
            },
            {
              id: 3,
              title: 'Sarung tangan'
            },
            {
              id: 4,
              title: 'Sikat lantai'
            },
            {
              id: 5,
              title: 'Vacuum Cleaner'
            },
            {
              id: 6,
              title: 'Wiper jendela'
            },
            {
              id: 7,
              title: 'Sikat gigi'
            },
            {
              id: 8,
              title: 'Lap Plas Chamois'
            },
            {
              id: 9,
              title: 'Sabut pembersih'
            },
            {
              id: 10,
              title: 'Stik pembersih'
            },
            {
              id: 11,
              title: 'Cairan pembersih'
            },
            {
              id: 12,
              title: 'Microfiber mop'
            }
          ]
        },
        {
          id: 6,
          type: 'BULLET',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Pembersihan durasi waktu ditentukan jumlah maximal ruangan, agar vendor dapat mengerjakan secara detail dan menghasilkan pembersihan secara maximal.'
            },
            {
              id: 2,
              title:
                'Kotoran yang membandel seperti jamur, bercak pada granit, kaca, sofa, tempat tidur, dan kerak pada kamar mandi tidak dapat dibersihkan secara maksimal karena dibutuhkan teknik, alat, dan cairan khusus.'
            },
            {
              id: 3,
              title:
                'Kami memberikan suport asuransi perlindungan pada setiap layanan kami, baca selengkapnya.'
            },
            {
              id: 4,
              title:
                'Halojasa tidak bertanggung jawab atas transaksi yang terjadi di luar aplikasi kami, dan pada saat kamu melakukan pemesanan, Pelanggan telah setuju dengan aturan dan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 2,
      image: HC2,
      title: 'Panduan Paket Residential',
      subtitle: [
        'Berikut ruangan yang termasuk dalam layanan  paket residential cleaning  contoh estimasi waktu pengerjaannya. Estimasi waktu dapat bervariasi tergantung pada ukuran dan kondisi kebersihan ruangan dan juga permintaan durasi pengerjaan.'
      ],
      alert_card:
        'Kami tidak bertangung jawab atas transaksi yang terjadi diluar aplikasi, Mohon memberi informasi kepada vendor kami apabila ingin mengunakan peralatan cleaning pribadi, termasuk menggunakan pengharum ruangan pribadi, sebelum pekerjaan dimulai.',
      content: [
        {
          id: 1,
          type: 'DURATION_CHOICE',
          title: 'Durasi pilihan pengerjaan :',
          content: [
            {
              id: 1,
              title: '180 menit  ( Luas bangunan  60m2 - 90m2)'
            },
            {
              id: 2,
              title: '270 menit  ( Luas bangunan 120m2 - 200m2)'
            }
          ]
        },
        {
          id: 2,
          type: 'DURATION_WITH_SIZE',
          detail_content: [
            {
              id: 1,
              title: 'Kamar Tidur',
              subtitle: '+/- 20-40  menit',
              size: '10 - 30 m2'
            },
            {
              id: 2,
              title: 'Kamar Mandi',
              subtitle: '+/- 30-60  menit',
              size: '4 - 12 m2'
            },
            {
              id: 3,
              title: 'Ruang Makan',
              subtitle: '+/- 20-30  menit',
              size: '15 - 30 m2'
            },
            {
              id: 4,
              title: 'Ruang keluarga',
              subtitle: '+/- 30-50  menit',
              size: '15 - 30 m2'
            },
            {
              id: 5,
              title: 'Ruang Tamu',
              subtitle: '+/-  30-50  menit',
              size: '10 - 30 m2'
            },
            {
              id: 6,
              title: 'Ruang Dapur',
              subtitle: '+/- 30--40  menit',
              size: '6- 15 m2'
            }
          ]
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Pengerjaan Layanan ini meliputi :',
          detail_content: [
            {
              id: 1,
              title:
                'Standar dusting : mengelap & memberikan  debu dan kotoran di area,'
            },
            {
              id: 2,
              title: 'Standar Sweeping : menyapu dan mengepel lantai area'
            },
            {
              id: 3,
              title: 'Clean Area : Pembersihan dan pembuangan sampah'
            }
          ]
        },
        {
          id: 4,
          type: 'CROSS',
          title: 'Layanan ini tidak termasuk, :',
          detail_content: [
            {
              id: 1,
              title:
                'Pembersihan area yang tidak bisa dijangkau dengan alat vendor kami.'
            },
            {
              id: 2,
              title:
                'Pembersihan jamur, kerak, cat, atau lumut, yang memerlukan cairan khusus.'
            },
            {
              id: 3,
              title: 'Pembersihan exhaust fan, atau kipas langit langit.'
            },
            {
              id: 4,
              title: 'Pembersihan lampu mewah langit langit.'
            },
            {
              id: 5,
              title:
                'Pembersihan saluran air yang mampet, serta pemasangan keran atau pipa.'
            },
            {
              id: 6,
              title: 'Pembersihan taman dan/atau garas.'
            },
            {
              id: 7,
              title: 'Pembersihan kotoran /kandang hewan dan/atau manusia.'
            },
            {
              id: 8,
              title: 'Pengangkutan dan pindahan barang.'
            },
            {
              id: 9,
              title: 'Pengurasan bak mandi, toren.'
            },
            {
              id: 10,
              title: 'Jemur dan angkat pakaian.'
            },
            {
              id: 11,
              title: 'Pembersihan barang mewah / koleksi pecah bela.'
            }
          ]
        },
        {
          id: 5,
          type: 'VENDOR_EQUIPMENT',
          title: 'Peralatan dan Perlengkapan vendor :',
          detail_content: [
            {
              id: 1,
              title: 'Lap microfiber'
            },
            {
              id: 2,
              title: 'Spons'
            },
            {
              id: 3,
              title: 'Sarung tangan'
            },
            {
              id: 4,
              title: 'Sikat lantai'
            },
            {
              id: 5,
              title: 'Vacuum Cleaner'
            },
            {
              id: 6,
              title: 'Wiper jendela'
            },
            {
              id: 7,
              title: 'Sikat gigi'
            },
            {
              id: 8,
              title: 'Lap Plas Chamois'
            },
            {
              id: 9,
              title: 'Sabut pembersih'
            },
            {
              id: 10,
              title: 'Stik pembersih'
            },
            {
              id: 11,
              title: 'Cairan pembersih'
            },
            {
              id: 12,
              title: 'Microfiber mop'
            }
          ]
        },
        {
          id: 6,
          type: 'BULLET',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Pembersihan durasi waktu ditentukan jumlah maximal ruangan, agar vendor dapat mengerjakan secara detail dan menghasilkan pembersihan secara maximal.'
            },
            {
              id: 2,
              title:
                'Kotoran yang membandel seperti jamur, bercak pada granit, kaca, sofa, tempat tidur, dan kerak pada kamar mandi tidak dapat dibersihkan secara maksimal karena dibutuhkan teknik, alat, dan cairan khusus.'
            },
            {
              id: 3,
              title:
                'Untuk layanan tambahan pembersihan kulkas, pembersihan rak meliputi proses pencucian dan pemisahan makanan kemasan yang telah kadaluarsa.'
            },
            {
              id: 4,
              title:
                'Pada saat pengerjaan mohon, menyimpan barang berharga pada tempatnya. '
            },
            {
              id: 5,
              title:
                'Tidak memberikan tugas untuk membersihkan barang koleksi mewah yang rawan pecah, pada saat layanan sedang berlangsung'
            },
            {
              id: 6,
              title:
                'Kami memberikan suport asuransi perlindungan pada setiap layanan kami, baca selengkapnya.'
            },
            {
              id: 7,
              title:
                'Halojasa tidak bertanggung jawab atas transaksi yang terjadi di luar aplikasi kami, dan pada saat kamu melakukan pemesanan, Pelanggan telah setuju dengan aturan dan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 3,
      image: HC3,
      title: 'Panduan Layanan Home Cleaning',
      subtitle: [
        'Berikut ruangan yang termasuk dalam layanan Home Cleaning beserta contoh luas dan estimasi waktu pengerjaannya. Estimasi waktu dapat bervariasi tergantung pada ukuran dan kondisi kebersihan ruangan dan juga permintaan durasi pengerjaan.'
      ],
      alert_card:
        'Kami tidak bertangung jawab atas transaksi yang terjadi diluar aplikasi, Mohon memberi informasi kepada vendor kami apabila ingin mengunakan peralatan cleaning pribadi, termasuk menggunakan pengharum ruangan pribadi, sebelum pekerjaan dimulai.',
      content: [
        {
          id: 1,
          type: 'DURATION_CHOICE',
          title: 'Durasi pilihan pengerjaan :',
          content: [
            {
              id: 1,
              title: '1jam  (Max 2 ruangan)'
            },
            {
              id: 2,
              title: '2jam  (Max 4 ruangan)'
            },
            {
              id: 3,
              title: '3 jam  (Max 6 ruangan)'
            },
            {
              id: 4,
              title: '4 jam  (Max 8 ruangan)'
            },
            {
              id: 5,
              title: '6 jam  (Max 12 ruangan)'
            }
          ]
        },
        {
          id: 2,
          type: 'DURATION_WITH_SIZE',
          detail_content: [
            {
              id: 1,
              title: 'Kamar Tidur',
              subtitle: '+/- 20-50  menit',
              size: '10 - 30 m2'
            },
            {
              id: 2,
              title: 'Kamar Mandi',
              subtitle: '+/- 30-60  menit',
              size: '4 - 12 m2'
            },
            {
              id: 3,
              title: 'Ruang Makan',
              subtitle: '+/- 20-30  menit',
              size: '15 - 30 m2'
            },
            {
              id: 4,
              title: 'Ruang keluarga',
              subtitle: '+/- 30-60  menit',
              size: '15 - 30 m2'
            },
            {
              id: 5,
              title: 'Ruang Tamu',
              subtitle: '+/-  30-90  menit',
              size: '10 - 30 m2'
            },
            {
              id: 6,
              title: 'Ruang Dapur',
              subtitle: '+/- 30--60  menit',
              size: '6- 15 m2'
            }
          ]
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Pengerjaan Layanan ini meliputi :',
          detail_content: [
            {
              id: 1,
              title:
                'Standar dusting : mengelap & memberikan  debu dan kotoran di area,'
            },
            {
              id: 2,
              title: 'Standar Sweeping : menyapu dan mengepel lantai area'
            },
            {
              id: 3,
              title: 'Clean Area : Pembersihan dan pembuangan sampah'
            },
            {
              id: 4,
              title:
                'Layanan tambahan sesuai pesanan: pembersihan teras/ balkon setrika pakaian,cuci piring, pembersihan kitchenset dan pembersihan kulkas, pembersihan toran air.'
            },
            {
              id: 5,
              title:
                'Untuk layanan tambahan setrika pakaian, estimasi per 12 potong pakaian.'
            }
          ]
        },
        {
          id: 4,
          type: 'CROSS',
          title: 'Layanan ini tidak termasuk, :',
          detail_content: [
            {
              id: 1,
              title:
                'Pembersihan area yang tidak bisa dijangkau dengan alat vendor kami.'
            },
            {
              id: 2,
              title:
                'Pembersihan jamur, kerak, cat, atau lumut, yang memerlukan cairan khusus.'
            },
            {
              id: 3,
              title: 'Pembersihan exhaust fan, atau kipas langit langit.'
            },
            {
              id: 4,
              title: 'Pembersihan lampu mewah langit langit.'
            },
            {
              id: 5,
              title:
                'Pembersihan saluran air yang mampet, serta pemasangan keran atau pipa.'
            },
            {
              id: 6,
              title: 'Pembersihan taman dan/atau garas.'
            },
            {
              id: 7,
              title: 'Pembersihan kotoran /kandang hewan dan/atau manusia.'
            },
            {
              id: 8,
              title: 'Pengangkutan dan pindahan barang.'
            },
            {
              id: 9,
              title: 'Pengurasan bak mandi, toren.'
            },
            {
              id: 10,
              title: 'Jemur dan angkat pakaian.'
            },
            {
              id: 11,
              title: 'Pembersihan barang mewah / koleksi pecah bela.'
            }
          ]
        },
        {
          id: 5,
          type: 'VENDOR_EQUIPMENT',
          title: 'Peralatan dan Perlengkapan vendor :',
          detail_content: [
            {
              id: 1,
              title: 'Lap microfiber'
            },
            {
              id: 2,
              title: 'Spons'
            },
            {
              id: 3,
              title: 'Sarung tangan'
            },
            {
              id: 4,
              title: 'Sikat lantai'
            },
            {
              id: 5,
              title: 'Vacuum Cleaner'
            },
            {
              id: 6,
              title: 'Wiper jendela'
            },
            {
              id: 7,
              title: 'Sikat gigi'
            },
            {
              id: 8,
              title: 'Lap Plas Chamois'
            },
            {
              id: 9,
              title: 'Sabut pembersih'
            },
            {
              id: 10,
              title: 'Stik pembersih'
            },
            {
              id: 11,
              title: 'Cairan pembersih'
            },
            {
              id: 12,
              title: 'Microfiber mop'
            }
          ]
        },
        {
          id: 6,
          type: 'BULLET',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Pembersihan durasi waktu ditentukan jumlah maximal ruangan, agar vendor dapat mengerjakan secara detail dan menghasilkan pembersihan secara maximal.'
            },
            {
              id: 2,
              title:
                'Kotoran yang membandel seperti jamur, bercak pada granit, kaca, sofa, tempat tidur, dan kerak pada kamar mandi tidak dapat dibersihkan secara maksimal karena dibutuhkan teknik, alat, dan cairan khusus.'
            },
            {
              id: 3,
              title:
                'Untuk layanan tambahan pembersihan kulkas, pembersihan rak meliputi proses pencucian dan pemisahan makanan kemasan yang telah kadaluarsa.'
            },
            {
              id: 4,
              title:
                'Pada saat pengerjaan mohon, menyimpan barang berharga pada tempatnya. '
            },
            {
              id: 5,
              title:
                'Tidak memberikan tugas untuk membersihkan barang koleksi mewah yang rawan pecah. Pada saat layanan sedang berlangsung'
            },
            {
              id: 6,
              title:
                'Kami memberikan suport asuransi perlindungan pada setiap layanan kami, baca selengkapnya.'
            },
            {
              id: 7,
              title:
                'Halojasa tidak bertanggung jawab atas transaksi yang terjadi di luar aplikasi kami, dan pada saat kamu melakukan pemesanan, Pelanggan telah setuju dengan aturan dan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 4,
      image: HC4,
      title: 'Panduan Office Cleaning',
      subtitle: [
        'Berikut ruangan yang termasuk dalam layanan Office Cleaning beserta estimasi waktu pengerjaannya. Estimasi waktu dapat bervariasi tergantung pada ukuran dan kondisi kebersihan ruangan dan juga permintaan durasi pengerjaan.'
      ],
      alert_card:
        'Kami tidak bertangung jawab atas transaksi yang terjadi diluar aplikasi, Mohon memberi informasi kepada vendor kami apabila ingin mengunakan peralatan cleaning pribadi, termasuk menggunakan pengharum ruangan pribadi, sebelum pekerjaan dimulai.',
      content: [
        {
          id: 1,
          type: 'DURATION_CHOICE',
          title: 'Durasi pilihan pengerjaan :',
          content: [
            {
              id: 1,
              title: '1jam  (Max 2 ruangan)'
            },
            {
              id: 2,
              title: '2jam  (Max 4 ruangan)'
            },
            {
              id: 3,
              title: '3 jam  (Max 6 ruangan)'
            },
            {
              id: 4,
              title: '4 jam  (Max 8 ruangan)'
            },
            {
              id: 5,
              title: '6 jam  (Max 12 ruangan)'
            }
          ]
        },
        {
          id: 2,
          type: 'DURATION',
          detail_content: [
            {
              id: 1,
              title: 'Ruangan Kerja',
              subtitle: '+/- 20-50  menit'
            },
            {
              id: 2,
              title: 'Ruangan Meeting',
              subtitle: '+/- 30-60  menit'
            },
            {
              id: 3,
              title: 'Ruang Toilet',
              subtitle: '+/- 20-30  menit'
            },
            {
              id: 4,
              title: 'Ruang Loby',
              subtitle: '+/- 30-60  menit'
            },
            {
              id: 5,
              title: 'Ruang Tamu',
              subtitle: '+/-  30-90  menit'
            },
            {
              id: 6,
              title: 'Ruang Dapur',
              subtitle: '+/- 30--60  menit'
            }
          ]
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Pengerjaan Layanan ini meliputi :',
          detail_content: [
            {
              id: 1,
              title:
                'Standar dusting : mengelap & memberikan  debu dan kotoran di area,'
            },
            {
              id: 2,
              title: 'Standar Sweeping : menyapu dan mengepel lantai area'
            },
            {
              id: 3,
              title: 'Clean Area : Pembersihan dan pembuangan sampah'
            }
          ]
        },
        {
          id: 4,
          type: 'CROSS',
          title: 'Layanan ini tidak termasuk, :',
          detail_content: [
            {
              id: 1,
              title:
                'Pembersihan area yang tidak bisa dijangkau dengan alat vendor kami.'
            },
            {
              id: 2,
              title:
                'Pembersihan jamur, kerak, cat, atau lumut, yang memerlukan cairan khusus.'
            },
            {
              id: 3,
              title: 'Pembersihan exhaust fan, atau kipas langit langit.'
            },
            {
              id: 4,
              title: 'Pembersihan lampu mewah langit langit.'
            },
            {
              id: 5,
              title:
                'Pembersihan saluran air yang mampet, serta pemasangan keran atau pipa.'
            },
            {
              id: 6,
              title: 'Pembersihan taman dan/atau garas.'
            },
            {
              id: 7,
              title: 'Pembersihan kotoran /kandang hewan dan/atau manusia.'
            },
            {
              id: 8,
              title: 'Pengangkutan dan pindahan barang.'
            },
            {
              id: 9,
              title: 'Pengurasan bak mandi, toren.'
            },
            {
              id: 10,
              title: 'Jemur dan angkat pakaian.'
            },
            {
              id: 11,
              title: 'Pembersihan barang mewah / koleksi pecah bela.'
            }
          ]
        },
        {
          id: 5,
          type: 'VENDOR_EQUIPMENT',
          title: 'Peralatan dan Perlengkapan vendor :',
          detail_content: [
            {
              id: 1,
              title: 'Lap microfiber'
            },
            {
              id: 2,
              title: 'Spons'
            },
            {
              id: 3,
              title: 'Sarung tangan'
            },
            {
              id: 4,
              title: 'Sikat lantai'
            },
            {
              id: 5,
              title: 'Vacuum Cleaner'
            },
            {
              id: 6,
              title: 'Wiper jendela'
            },
            {
              id: 7,
              title: 'Sikat gigi'
            },
            {
              id: 8,
              title: 'Lap Plas Chamois'
            },
            {
              id: 9,
              title: 'Sabut pembersih'
            },
            {
              id: 10,
              title: 'Stik pembersih'
            },
            {
              id: 11,
              title: 'Cairan pembersih'
            },
            {
              id: 12,
              title: 'Microfiber mop'
            }
          ]
        },
        {
          id: 6,
          type: 'BULLET',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Pembersihan durasi waktu ditentukan jumlah maximal ruangan, agar vendor dapat mengerjakan secara detail dan menghasilkan pembersihan secara maximal.'
            },
            {
              id: 2,
              title:
                'Kotoran yang membandel seperti jamur, bercak pada granit, kaca, sofa, tempat tidur, dan kerak pada kamar mandi tidak dapat dibersihkan secara maksimal karena dibutuhkan teknik, alat, dan cairan khusus.'
            },
            {
              id: 3,
              title:
                'Untuk layanan tambahan pembersihan kulkas, pembersihan rak meliputi proses pencucian dan pemisahan makanan kemasan yang telah kadaluarsa.'
            },
            {
              id: 4,
              title:
                'Pada saat pengerjaan mohon, menyimpan barang berharga pada tempatnya. '
            },
            {
              id: 5,
              title:
                'Tidak memberikan tugas untuk membersihkan barang koleksi mewah yang rawan pecah, pada saat layanan sedang berlangsung'
            },
            {
              id: 6,
              title:
                'Kami memberikan suport asuransi perlindungan pada setiap layanan kami, baca selengkapnya.'
            },
            {
              id: 7,
              title:
                'Halojasa tidak bertanggung jawab atas transaksi yang terjadi di luar aplikasi kami, dan pada saat kamu melakukan pemesanan, Pelanggan telah setuju dengan aturan dan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    }
  ],
  HM: [
    {
      id: 1,
      image: HM1,
      title: 'Full Spa Body Massage',
      subtitle: [
        'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan special pure aromaterapi minyak esensial organik akan menenangkan, menghilangkan stres, dan mengurangi kecemasan.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Oil / Lotion / hot cream'
            },
            {
              id: 7,
              title: 'Essensial Oil lavender / lemograss'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle:
            '90,120,150,180  menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
            },
            {
              id: 2,
              title:
                'Teknik Pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern yang dilakukan pada posisi duduk hingga tidur dengan penekanan titik tubuh bagian kaki hingga ke bagian pungung,tangan dan kepala.'
            },
            {
              id: 3,
              title:
                'Penyegaran tubuh dengan massage oil aromateraphy yang hangat.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
            },
            {
              id: 2,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 4,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 2,
      image: HM2,
      title: 'Serenity Spa Reflexolgy & Body Massage',
      subtitle: [
        'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan special pure aromaterapi minyak esensial organik akan menenangkan, menghilangkan stres, dan mengurangi kecemasan.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Oil / Lotion / hot cream'
            },
            {
              id: 7,
              title: 'Foot Detox'
            },
            {
              id: 8,
              title: 'Foot backet'
            },
            {
              id: 9,
              title: 'Bath salt'
            },
            {
              id: 10,
              title: 'Foot balm'
            },
            {
              id: 11,
              title: 'Essensial Oil lavender / lemograss'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle:
            '90,120,150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Merupakan terapi pijat yang mengombinasikan teknik pijat tradisional dengan teknik refleksi kaki ,tubuh dan tangan, menjaga kualitas tubuh kamu menenangkan pikiran, dan meningkatkan kualitas tidur.'
            },
            {
              id: 2,
              title:
                'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
            },
            {
              id: 3,
              title:
                'Penyegaran tubuh dengan massage oil aromateraphy yang hangat dan perawatan kaki.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Harga tertera sudah termasuk standart peralatan kerja reflexology dan massage.'
            },
            {
              id: 2,
              title:
                'Pelanggan disarankan untuk menyiapkan air hangat untuk treatment kaki.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 4,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 5,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 3,
      image: HM3,
      title: '5 Star Reflexology',
      subtitle: [
        'Kaki anda juga layak untuk dimanja, rasakan pengalaman sensasi pelayanan bintang 5, Manjakan diri Anda dengan merendam dan merawat kaki anda dengan pijatan titik kaki yang akan bermanfaat mereales tubuh anda yang meningkatkan kebugaran dan kesehatan.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Foot Detox'
            },
            {
              id: 2,
              title: 'Foot backet'
            },
            {
              id: 3,
              title: 'Bath salt'
            },
            {
              id: 4,
              title: 'Foot balm'
            },
            {
              id: 5,
              title: 'Microfiber Towel'
            },
            {
              id: 6,
              title: 'Spa music speaker'
            },
            {
              id: 7,
              title: 'Aromatherapy difusser'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '60,90,menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Merupakan perawatan relaksasi kaki, dimulai dengan merendam kaki anda dengan air hangat dipadukan dengan taburan bath salt yang bermanfaat untuk kulit kaki anda.'
            },
            {
              id: 2,
              title:
                'Melakukan Pijatan pada posisi duduk, dengan penekanan ringan pada bagian telapak dan tungkai hingga betis kaki dan kombinasi pijat titik kaki hingga ke pungung,tangan dan kepala.'
            },
            {
              id: 3,
              title:
                'Penyegaran kaki dengan Aplikasi pijatan ringan dengan pengunaan foot balm.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Harga tertera sudah termasuk peralatan kerja dan cream perawatan kaki.'
            },
            {
              id: 2,
              title:
                'Pelanggan disarankan untuk menyiapkan air hangat sesuai kebutuhan.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 4,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 5,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku'
            }
          ]
        }
      ]
    },
    {
      id: 4,
      image: HM4,
      title: 'Full Spa Body Massage + Kerokan',
      subtitle: [
        'Berikan kesegaran pada tubuh Anda dengan pijatan yang akan merilekskan jaringan tubuh Anda yang lelah, sekaligus untuk mengatasi gejala masuk angin untuk meningkatkan kesehatan, Relaksasi Pijatan tradisional spa ditambah dengan tradisional treatment kerokaan untuk mengatasi gejala masuk angin untuk meningkatkan kesehatan.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Gpu Oil / hot cream'
            },
            {
              id: 7,
              title: 'Gua Sha tools'
            },
            {
              id: 8,
              title: 'Essensial Oil lavender / lemograss'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '120,150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Merupakan terapi pijat penenangan diri, untuk menghilangkan gejala masuk angin dan mengkombinasikan teknik pijat tradisional agar tubuh menjadi ringan dan sehat. '
            },
            {
              id: 2,
              title:
                'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik kerokan yang merangsang aliran energi dan meningkatkan penyembuhan.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title: 'Harga tertera sudah termasuk standart peralatan kerja.'
            },
            {
              id: 2,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 4,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 5,
      image: HM5,
      title: 'Full Spa Body Massage + Luluran',
      subtitle: [
        'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan juga perawatan kulit tubuh, dengan bahan organik, yang akan membantu menyegarkan tubuh dan mengeksfoliasi kulit tubuh kamu.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Oil / Lotion'
            },
            {
              id: 7,
              title: 'Foot balm'
            },
            {
              id: 8,
              title: 'Essensial Oil lavender / lemograss'
            },
            {
              id: 9,
              title: 'Varian Scrub / Boreh / Lulur'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Full body massage  dan lulur merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
            },
            {
              id: 2,
              title:
                'Merupakan terapi pijat yang mengombinasikan teknik pijat tradisional dengan teknik refleksi kaki ,tubuh ,tangan dan kepala mendorong kebugaran baru pada tubuh kamu.'
            },
            {
              id: 3,
              title:
                'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
            },
            {
              id: 4,
              title:
                'Treatment akhir selama 30-menit mengaplikasikan cream lulur/scrub/boreh untuk mengangkat sel kulit mati serta menyegarkan dan menghaluskan kulit tubuh.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Harga tertera sudah termasuk standart peralatan kerja full body massage.'
            },
            {
              id: 2,
              title:
                'Harga termasuk lulur,boreh dan scrub yang dapat dipilih sesuai kebutuhan.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 4,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 5,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 6,
      image: HM6,
      title: 'Full Spa Massage Lulur + Masker Badan',
      subtitle: [
        'Mengembalikan suasana hati dan merileksasi kan tubuh, dengan pijat tradisional kami dan juga perawatan lulur scrub & masker badan, dengan bahan organik, yang akan membantu menyegarkan tubuh dan mengeksfoliasi kulit tubuh kamu.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Oil / Lotion'
            },
            {
              id: 7,
              title: 'Essensial Oil lavender / lemograss'
            },
            {
              id: 8,
              title: 'Peel Off Body Mask Spa '
            },
            {
              id: 9,
              title: 'Varian Scrub / Boreh / Lulur (dapat dipilih)'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '120,150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Full body massage lulur & masker badan merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan,serta merawat kulit tubuh, mengangkat sel kulit mati  dan menghaluskan kulit. '
            },
            {
              id: 2,
              title:
                'Mengkombinasikan teknik pijatan 5 dasar gerakan pijatan tradisional dengan teknik pijat penekanan titik-titik refleksi pada kaki,punggung,tangan,kepala serta area perawatan yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
            },
            {
              id: 3,
              title:
                'Masker badan selama 15 - 30 +/- menit pd area punggung untuk menyegarkan dan menghaluskan kulit tubuh.'
            },
            {
              id: 4,
              title:
                'Lulur selama 30 - 60 +/- menit mengaplikasikan cream lulur/scrub pd area lengan ,kaki , dada atas  untuk mengangkat sel kulit mati.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title: 'Harga tertera sudah termasuk standart peralatan kerja .'
            },
            {
              id: 2,
              title:
                'Harga termasuk lulur,boreh dan scrub yang dapat dipilih sesuai kebutuhan.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 4,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 5,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 7,
      image: HM7,
      title: 'Full Spa Massage + Perawatan Lengkap',
      subtitle: [
        'Mengembalikan suasana hati dan merileksasi kan tubuh, dengan pijat tradisional kami dan juga perawatan lulur scrub & masker badan serta face mask dengan bahan organik, yang akan membantu menyegarkan tubuh dan wajah kamu.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Oil / Lotion'
            },
            {
              id: 7,
              title: 'Essensial Oil lavender / lemograss'
            },
            {
              id: 8,
              title: 'Peel Off Body Mask spa'
            },
            {
              id: 9,
              title: 'Varian Peel Off Face Mask (dapat dipilih)'
            },
            {
              id: 10,
              title: 'Varian Scrub / Boreh / Lulur (dapat dipilih)'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Full massage dan perawatan lengkap merupakan perawatan, relexasi tubuh yang memberikan manfaat kesehatan, serta merawat kulit tubuh dan wajah untuk mengangkat sel kulit mati dan menghaluskan kulit.'
            },
            {
              id: 2,
              title:
                'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
            },
            {
              id: 3,
              title:
                'Masker badan selama 15 - 30 +/- menit pd area bagian punggung untuk menyegarkan dan menghaluskan kulit tubuh.'
            },
            {
              id: 4,
              title:
                'Lulur selama 45 - 60 +/- menit mengaplikasikan cream lulur/scrub pd area. seluruh lengan ,seluruh kaki, bagian dada atas  untuk mengangkat sel kulit mati.'
            },
            {
              id: 5,
              title:
                'Masker wajah selama 15 - 30 +/- menit untuk merawat dan menyegarkan serta menghaluskan kulit wajah.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title: 'Harga tertera sudah termasuk standart peralatan kerja.'
            },
            {
              id: 2,
              title:
                'Harga termasuk lulur,scrub & masker wajah yang dapat dipilih vairan nya sesuai kebutuhan.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 4,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 5,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 8,
      image: HM8,
      title: 'Hot Stone Spa Massage',
      subtitle: [
        'Relaksasi pijatan klasik hydroterapi dengan menggunakan batu vulkanik,bermanfaat mengurangi stres dan kecemasan untuk Meningkatkan fleksibilitas sendi dan otot tubuh serta Meningkatkan kualitas tidur.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Essensial Oil lavender / lemograss'
            },
            {
              id: 7,
              title: 'Oil / Lotion / hot cream'
            },
            {
              id: 8,
              title: 'Hot stone & Heater Box'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '120,150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
            },
            {
              id: 2,
              title:
                'Teknik Pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat yang memanfaatkan batu basal yang telah dipanaskan dan digerakan dengan teknik pijatan yang fokus pijatan pada beberapa titik tertentu tubuh.'
            },
            {
              id: 3,
              title:
                'Diakhiri dengan meletakan kehangatan batu di beberapa bagian tubuh seperti punggung dan pinggang, tangan, kaki, perut.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
            },
            {
              id: 2,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 4,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 9,
      image: HM9,
      title: ' Massage + Totok Wajah & Masker ',
      subtitle: [
        'Mengembalikan suasana hati dan menghilangkan stres anda, dengan pijat tradisional kami dan juga fokus terhadap perawatan kulit wajah, dengan bahan organik, yang akan membantu menyegarkan serta mencerahkan kulit wajah.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Oil / Lotion'
            },
            {
              id: 7,
              title: 'Face cream'
            },
            {
              id: 8,
              title: 'Essensial Oil lavender / lemograss'
            },
            {
              id: 9,
              title: 'Varian Mask peel off organik'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Full body massage proses pijat mengunakan teknik pijatan 5 dasar  gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
            },
            {
              id: 2,
              title:
                'Totok wajah memadukan dua teknik acupressure & bioenergi tenaga yang fokus pada titik-titik tertentu pada wajah yang mendorong kelancaran aliran darah'
            },
            {
              id: 3,
              title:
                'Treatment akhir selama 30-menit mengaplikasikan masker peel off untuk mengangkat sel kulit mati dan menghaluskan kulit wajah.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Harga tertera sudah termasuk standart peralatan kerja full body massage.'
            },
            {
              id: 2,
              title:
                'Harga termasuk masker oragnik peel off yang dapat dipilih sesuai kebutuhan.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 4,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 5,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 10,
      image: HM10,
      title: 'Full Spa Body Massage + Creambath',
      subtitle: [
        'Mengembalikan suasana hati dan menghilangkan stres dan ketegangan otot tubuh, dengan pijat tradisional kami sekaligus melakukan perawatan kulit kepala dan rambut, dengan bahan organik, memberikan kesegaran pada kulit kepala dengan pijatan yang akan merilekskan jaringan tubuh anda yang lelah.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa cap hair'
            },
            {
              id: 6,
              title: 'Spa music speaker'
            },
            {
              id: 7,
              title: 'Oil / Lotion / hot cream'
            },
            {
              id: 8,
              title: 'Hair mask creambath '
            },
            {
              id: 9,
              title: 'Essensial Oil lavender / lemograss'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
            },
            {
              id: 2,
              title:
                'Teknik Pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern yang dilakukan pada posisi duduk hingga tidur dengan penekanan titik tubuh bagian kaki hingga ke bagian pungung,tangan dan kepala.'
            },
            {
              id: 3,
              title:
                'Teknik pijatan kepala selama 30 menit tekanan lembut  dengan mengerakan melingkar berulang kali kepada kepala dengan diakhiri mengaplikasikan hair mask .'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
            },
            {
              id: 2,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 4,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 11,
      image: HM11,
      title: 'Full Spa body massage + Dry Cupping',
      subtitle: [
        'Terapi pijat kesehatan untuk memperbaiki sistem Imun tubuh untuk mengatasi gejala masuk angin, dengan alternatif penganti kerokan, ditambah dengan pijatan yang akan merilekskan jaringan tubuh anda yang lelah, sekaligus untuk mengatasi  tubuh yang lelah dan membantu meningkatkan kesehatan tubuh.'
      ],
      alert_card:
        'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Aromatherapy difusser'
            },
            {
              id: 4,
              title: 'Microfiber Towel'
            },
            {
              id: 5,
              title: 'Spa music speaker'
            },
            {
              id: 6,
              title: 'Gpu Oil / hot cream'
            },
            {
              id: 7,
              title: 'Cup complit tools'
            },
            {
              id: 8,
              title: 'Essensial Oil lavender / lemograss'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '150,180 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Full body massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan dan mengembalikan kebugaran tubuh melalui perengangan, tekanan pada gerakan mengunakan angota tubuh.'
            },
            {
              id: 2,
              title:
                'Merupakan layanan relaxasi pijat yang mengkombinasikan teknik pijat tradisional dengan teknik refleksi kaki ,tubuh ,tangan dan kepala mendorong kebugaran baru pada tubuh kamu.'
            },
            {
              id: 3,
              title:
                'Dalam proses pijat mengunakan teknik pijatan 5 dasar gerakan pijatan tradisional dikombinasikan dengan teknik pijat modern penekanan titik-titik refleksi pada kaki,punggung,tangan dan kepala yang dipercaya dapat menstimulasi organ-organ dalam tubuh.'
            },
            {
              id: 4,
              title:
                'Treatment akhir selama 30-menit, mengaplikasikan terapi bekam kering dengan standarisasi sop dan peralatan bekam.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Standart Peralatan Kerja:',
          detail_content: [
            {
              id: 1,
              title:
                'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan peralatan bekam (cup) yang mitra kami bawa selalu kami lakukan setrilasisi dengan pengunanaa mesin seterilisator dan dibasuh dengan alkhohol.'
            }
          ]
        },
        {
          id: 5,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title: 'Harga tertera sudah termasuk standart peralatan kerja.'
            },
            {
              id: 2,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 4,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 12,
      image: HM12,
      title: 'Sprain Massage',
      subtitle: [
        'Bertujuan untuk merenggangkan otot, mencegah cedera, mengatasi sakit terhadap otot terkilir. meningkatkan aliran darah ke area yang cedera sehingga dapat mempercepat proses pemulihan, dan kami melakukan terapi pijat toleransi hanya terhadap nyeri dan cidera ringan.'
      ],
      alert_card:
        'Pelangan terhormat, Konsultasikan terlebih dahulu dengan dokter Anda sebelum memutuskan untuk mendapatkan terapi pijat oleh teraphis specialisasi kami',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Premium mattras'
            },
            {
              id: 2,
              title: 'Disposible bed sheet'
            },
            {
              id: 3,
              title: 'Microfiber Towel'
            },
            {
              id: 4,
              title: 'Spa music speaker'
            },
            {
              id: 5,
              title: 'Oil / Lotion / hot cream'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '90,120, menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Sprain massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat Perawatan khusus untuk otot atau persendian yang mengalami permasalahan pembengkakan atau rasa sakit akibat keselo/terkilir '
            },
            {
              id: 2,
              title:
                'Mengunakan dua teknik cross-friction massage pijatan yang mencegah perlengketan jaringan luka yang terjadi di ligamen dan teknik pijatan limfatic untuk bertujuan mengurangi pembengkakan pada kaki yang terkilir.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Standart Peralatan Kerja:',
          detail_content: [
            {
              id: 1,
              title:
                'Pelangan terhormat, untuk kepuasan dan kenyamanan anda setiap pengunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per custumer dan terstandarisasi dgn cuci laundry.'
            }
          ]
        },
        {
          id: 5,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title: 'Harga tertera sudah termasuk standart peralatan kerja.'
            },
            {
              id: 2,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 4,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            }
          ]
        }
      ]
    },
    {
      id: 13,
      image: HM13,
      title: 'Pregnancy Massage',
      subtitle: [
        'Prenatal massage\nPerawatan dan relaxasi disarankan di atas usia 12 minggu meningkatkan sirkulasi darah, menghilangkan pegal dan nyeri otot, untuk melancarkan aliran darah ke seluruh tubuh dan janin, Menstabilkan hormon di dalam tubuh, baik kesehatan fisik dan psikis ibu hamil,dan mempersiapkan tubuh lebih baik menjelang hari persalinan.',
        'Postnatal Massage\nPerawatan dan relaxasi untuk meningkatkan kebahagiaan. meningkatkan sirkulasi darah, menghilangkan pegal dan nyeri otot, pereda sakit, menstabilkan hormon serta menurunkan kadar hormon kortisol berlebihan saat pasca melahirkan agar ibu lebih relax.'
      ],
      alert_card:
        'Pelangan terhormat, Konsultasikan terlebih dahulu dengan dokter Anda sebelum memutuskan untuk mendapatkan relaksasi pijat oleh teraphis specialisasi kami',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Disposible bed sheet'
            },
            {
              id: 2,
              title: 'Aromatherapy difusser'
            },
            {
              id: 3,
              title: 'Microfiber Towel'
            },
            {
              id: 4,
              title: 'Spa music speaker'
            },
            {
              id: 5,
              title: 'Special Oil  Organic'
            },
            {
              id: 6,
              title: 'Essensial Oil organik lavender'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '90,120, menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Pregnancy  massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan pada ibu hamil dan pasca melahitkan untuk mengembalikan kebugaran tubuh  dan mood.'
            },
            {
              id: 2,
              title:
                'Mengabungkan pijatan oksitosin, dan laktasi  gerakan pijatan ringan dengan tekanan usapan lembut dan menyesuaikan dengan titik-titik tertentu yang diperbolehkan untuk dipijat saat hamil. dan dilakukan pada posisi duduk dan posisi berbaring menyamping.'
            },
            {
              id: 3,
              title:
                'Memfokuskan titik titik pijatan yang memahami kondisi pasca persalinan, baik itu untuk yang menjalani operasi atau melahirkan secara normal,pijatan dilakukan pada  seluruh tubuh ini melibatkan pembalutan perut dan juga payudara untuk mempelancar asi.'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Pelanggan terhormat, untuk kepuasan dan kenyamanan anda setiap penggunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per customer dan standarisasi dengan cuci laundry'
            },
            {
              id: 2,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 4,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            },
            {
              id: 5,
              title:
                'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
            }
          ]
        }
      ]
    },
    {
      id: 14,
      image: HM14,
      title: 'Mom and Baby Massage',
      subtitle: [
        'Mom Massage\nPerawatan dan relaxasi untuk meningkatkan kebahagiaan.meningkatkan sirkulasi darah, menghilangkan pegal dan nyeri otot, pereda sakit, menstabilkan hormon serta menurunkan kadar hormon kortisol berlebihan saat pasca melahirkan agar ibu lebih relax',
        'Baby Massage\nMerupakan perawatan terapi relaksasi bayi dengan teknik pijat ringan untuk merangsang stimulasi positif.'
      ],
      alert_card:
        'Pelangan terhormat, Konsultasikan terlebih dahulu dengan dokter Anda sebelum memutuskan untuk mendapatkan relaksasi pijat oleh teraphis specialisasi kami',
      content: [
        {
          id: 1,
          type: 'VENDOR_EQUIPMENT',
          title: 'Standart Peralatan Kerja & Kompliment:',
          detail_content: [
            {
              id: 1,
              title: 'Disposible bed sheet'
            },
            {
              id: 2,
              title: 'Aromatherapy difusser'
            },
            {
              id: 3,
              title: 'Microfiber Towel'
            },
            {
              id: 4,
              title: 'Baby Spa music speaker'
            },
            {
              id: 5,
              title: 'Special Oil  Organic'
            },
            {
              id: 6,
              title: 'Essensial Oil Organik lavender'
            }
          ]
        },
        {
          id: 2,
          type: 'TOTAL_DURATION',
          title: 'Waktu Durasi Pilihan:',
          subtitle: '120,150 menit (sesuai dengan durasi layanan terpilih)'
        },
        {
          id: 3,
          type: 'CHECKLIST',
          title: 'Cakupan Standart Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Mom massage merupakan perawatan dan relexasi tubuh yang memberikan manfaat kesehatan pada ibu hamil dan pasca melahitkan untuk mengembalikan kebugaran tubuh  dan mood.'
            },
            {
              id: 2,
              title:
                'Mengabungkan pijatan oksitosin, dan laktasi teknik pijatan ringan  untuk ibu yang memfokuskan titik titik pijatan yang memahami kondisi pasca persalinan,baik itu untuk yang menjalani operasi atau melahirkan secara normal,pijatan dilakukan pada  seluruh tubuh ini melibatkan pembalutan perut dan payudara mempelancar asi.'
            },
            {
              id: 3,
              title:
                'Teknik Baby massage pijatan ringan dengan cara mengusap atau mengelus tubuh bayi agar menimbulkan efek nyaman dan membantu relaksasi otot tubuh bayi'
            }
          ]
        },
        {
          id: 4,
          type: 'CHECKLIST',
          title: 'Ketentuan Layanan:',
          detail_content: [
            {
              id: 1,
              title:
                'Pelanggan terhormat, untuk kepuasan dan kenyamanan anda setiap penggunaan handuk (towel) yang mitra kami bawa hanya digunakan 1x per customer dan standarisasi dengan cuci laundry'
            },
            {
              id: 2,
              title: 'Harga sudah termasuk biaya transportasi home service.'
            },
            {
              id: 3,
              title: 'Harga sudah termasuk Asuransi.'
            },
            {
              id: 4,
              title:
                'Dengan melakukan pemesanan, pelanggan telah setuju dengan ketentuan yang berlaku.'
            },
            {
              id: 5,
              title:
                'Harga tertera sudah termasuk standart peralatan kerja & aromaterphy oil essensial.'
            }
          ]
        }
      ]
    }
  ]
}

export default { content_type, detail_service_product }
